import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import { useState } from 'react';

import { TextFieldProps } from '@mui/material';
import RFFTextField from './RFFTextField';

type RFFPasswordProps = {
  name?: string;
  label: string;
  testId?: string;
} & Omit<TextFieldProps, 'type'>;
/**
 * @deprecated React Final Form has been deprecated in the system.
 * Components based on RFF are no longer supported.
 * Please use <InputAdornment /> or other updated alternatives.
 */
const RFFPassword = ({ name = 'password', label, ...rest }: RFFPasswordProps) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <RFFTextField
      type={showPassword ? 'text' : 'password'}
      label={label}
      name={name || 'password'}
      {...rest}
      slotProps={{
        input: {
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                size="small"
                aria-label="toggle password visibility"
                onClick={() => setShowPassword(!showPassword)}
                onMouseDown={(e) => e.preventDefault()}
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        },
      }}
    />
  );
};

export default RFFPassword;
